/** @jsxImportSource @emotion/react */
import { AddPlaceholder } from 'modules/template-editor/ui/components/editor/left-toolbar/add-placeholders/add-placeholder';
import React from 'react';
import { AddImage } from './add-image';
import { AddShape } from './add-shape';
import { AddText } from './add-text';
import { Copy } from './copy';
import { Delete } from './delete';
import { Group } from './group';
import { PenTool } from './pen-tool';
import { Redo } from './redo';
import { MainBlock } from './styles';
import { Undo } from './undo';

function LeftToolbar() {
  return (
    <MainBlock>
      <AddPlaceholder />
      <AddShape />
      <AddText />
      <PenTool />
      <AddImage />
      <Copy />
      <Group />
      <Undo />
      <Redo />
      <Delete />
    </MainBlock>
  );
}

export default LeftToolbar;
